'use memo';

import { AgxSpacer, AgxTypography, Icon_AlertCircle } from '@urbanx/agx.ui-components2';

const integrationErrorMessages = {
  'authorization-failed': 'We could not complete the authorization. Please try connecting again.',
  'authorization-url-failed':
    'We could not load the connection link. Please refresh and try again.',
  'connection-failed': 'We could not connect your account. Please try connecting again.',
  'invalid-account':
    'Ensure you are using the credentials for the account provided to you by Autopilot.',
} as const;

type IntegrationErrorCode = keyof typeof integrationErrorMessages;

interface IntegrationErrorProps {
  errorCode: IntegrationErrorCode;
  id: string;
  name: string;
}

export const isIntegrationErrorCode = (
  errorCode: string | null
): errorCode is IntegrationErrorCode =>
  errorCode === 'authorization-failed' ||
  errorCode === 'authorization-url-failed' ||
  errorCode === 'connection-failed' ||
  errorCode === 'invalid-account';

const IntegrationError = ({ errorCode, id, name }: IntegrationErrorProps) => (
  <AgxSpacer
    id={`${id}-integration-error`}
    data-testid={`${id}-integration-error`}
    role="alert"
    direction="horizontal"
    gap="spacing-md"
    padding="spacing-xl"
    className="onboarding-integration-error"
  >
    <Icon_AlertCircle type="danger" height={18} width={18} />
    <AgxSpacer direction="vertical" gap="spacing-md" fill>
      <AgxTypography
        id={`${id}-integration-error-heading`}
        type="body_ui_strong"
        size="small"
        color="var(--text-error, #e6281c)"
      >
        Error with {name} integration.
      </AgxTypography>
      <AgxSpacer direction="vertical" gap="spacing-md">
        <AgxTypography
          id={`${id}-integration-error-credentials`}
          type="body_ui"
          size="small"
          color="var(--text-error, #e6281c)"
        >
          {integrationErrorMessages[errorCode]}
        </AgxTypography>
        <AgxTypography
          id={`${id}-integration-error-support`}
          type="body_ui"
          size="small"
          color="var(--text-error, #e6281c)"
        >
          If issues persist, contact Autopilot support.
        </AgxTypography>
      </AgxSpacer>
    </AgxSpacer>
  </AgxSpacer>
);

export default IntegrationError;
